// Injected by Vite from package.json (see vite.config.ts). Import this constant anywhere
// the running version is needed — never hard-code a version string.
export const APP_VERSION: string = __APP_VERSION__;
